import { TimeOffPaidType } from './time-off-paid-type';
import { TimeOffTypeCode } from './time-off-type-code';

export class TimeOffType {
    public id: string;
    public code: TimeOffTypeCode;
    public name: string;
    public description: string;
    public active: boolean;
    public paid_type: TimeOffPaidType;
}   